import { render, staticRenderFns } from "./GenericKeys.vue?vue&type=template&id=130cc955&scoped=true&"
import script from "./GenericKeys.vue?vue&type=script&lang=js&"
export * from "./GenericKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130cc955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130cc955')) {
      api.createRecord('130cc955', component.options)
    } else {
      api.reload('130cc955', component.options)
    }
    module.hot.accept("./GenericKeys.vue?vue&type=template&id=130cc955&scoped=true&", function () {
      api.rerender('130cc955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/components/GenericKeys.vue"
export default component.exports